import { render, staticRenderFns } from "./RipaStudent.vue?vue&type=template&id=f59fafbc"
import script from "./RipaStudent.vue?vue&type=script&lang=js"
export * from "./RipaStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports